// CollapseData.js
const collapseData = [
  {
    title: 'Introduction',
    content: `
      <p>Yann GICQUEL, 34 ans.<br/>
      Titulaire d'un <span class="important-word">BEP de Comptabilité</span>, d'un <span class="important-word">BAC Pro de Commerce</span> 
      ainsi que d'un <span class="important-word">BAFA</span>, j'ai travaillé <span class="important-word">4 ans</span> 
      comme <span class="important-word">vendeur</span> chez Game puis Micromania. 
      Suite à une opportunité, j'ai travaillé pendant <span class="important-word">8 ans</span>
      comme <span class="important-word">animateur</span> dans un périscolaire auprès d'enfants de 3 à 12 ans.
      Au cours de cette aventure professionnelle, j'ai pu me former à la méthode de <span class="important-word">communication non-violente "Gordon"</span>. 
      <br />
      Ces expériences m'ont permis de développer de nombreuses compétences, telles que :</p>
      <ul>
        <li> Le dynamisme</li>
        <li> La patience</li>
        <li> L'écoute</li>
        <li> L'organisation</li>
        <li> L'empathie</li>
        <li> Le service client</li>
        <li> L'autonomie</li>
        <li> Un savoir-être en public</li>
      </ul>`
  },
  { title: 'Langues parlées', content: `
    <p>
      Ma <span class="important-word">langue maternelle est le français</span>, 
      j'ai aussi appris <span class="important-word">l'anglais</span>, principalement de manière autonome.
      Les cours que j'ai suivis au collège et au lycée m'ont surtout 
      apporté des bases sur lesquelles j'ai pu construire mon apprentissage.
      <br />
      Cet apprentissage autonome s'est fait, de manière très peu originale, 
      via l'écoute de musique, le visionnage de films et de séries,
      les jeux vidéo ainsi que de nombreuses lectures sur le web.
      <br/>
      Je pense que mon niveau d'anglais est globalement bon, suffisant pour tenir des conversations sur
      des sujets divers, personnels, culturels ou professionnels.
      <br />
      Lors de mon cursus scolaire, j'ai aussi appris 
      l'<span class="important-word">allemand</span>, 
      langue pour laquelle je n'ai que peu d'affinité mais possède tout de même quelques bases.
    </p>
    ` },
  { 
    title: 'Ma formation de développeur', 
    content: `
    <p>
    J'ai découvert le développement web un peu par hasard. 
    En effet, c'est suite à la reprise de l'association dans laquelle je travaillais 
    que je me suis retrouvé au chômage,
    et la question d'une reconversion s'est alors posée. Après quelques recherches, 
    je me suis rendu compte que le milieu du développement m'intéressait ; 
    j'ai donc commencé à apprendre le HTML, le CSS et le JavaScript
    de manière autodidacte. J'ai ensuite réussi à obtenir un financement 
    pour une formation auprès d'
      <a href="https://www.openclassrooms.com" target="_blank">OpenClassrooms</a>.
      <br /> 
      Cette formation, de mars à novembre 2024, m'a permis de découvrir plusieurs 
      aspects du travail de développeur :
      <ul>
        <li> Des bases solides en <strong>HTML</strong>, </li>
        <li> Des bases avancées en <strong>CSS/SASS</strong>, </li>
        <li> Une première approche des <strong>animations en CSS</strong>, </li>
        <li> Une meilleure compréhension de <strong>JavaScript</strong>, </li>
        <li> Des bases solides en <strong>React</strong>, </li>
        <li> Des notions de <strong>management</strong>, </li>
        <li> Les bases du <strong>back-end</strong>, </li>
        <li> De solides notions en <strong>optimisation et SEO</strong>.</li>
      </ul>
    </p>
      `
  },
  { title: 'Expérience en développement', content: `
    <p>
      J'aime relever de nouveaux défis, c'est pourquoi je suis enthousiaste à 
      l'idée d'explorer de nouvelles opportunités 
      et de collaborer sur des projets passionnants lors de ma première mission de développeur web.
    </p>
    ` },
  { 
    title: 'Passion', 
    content: `
      <p>Passionné par la <strong>musique</strong>, avec des goûts très éclectiques, 
      j'ai quelques années d'expérience en tant que <strong>bassiste</strong> dans des groupes (le dernier en date : <a target="_blank" rel="noreferrer"  href="https://www.youtube.com/watch?v=b6iwTz9IA_I">Davyn</a>).
      <br />
      Cette expérience m'a permis de développer <strong>des compétences en travail de groupe</strong>,
       notamment dans la <strong>gestion des conflits</strong>, et m'a aussi aidé à développer mes 
       <strong>compétences sociales</strong>.
      <p>
      Je suis passionné par les <strong>jeux vidéo</strong>, et depuis quelques années je m'intéresse 
      beaucoup à tout ce qui touche <strong>l'UI, l'UX</strong>, et les logiques de <strong>game design</strong>.
      </p>
      <p> 
      À côté de cela, j'ai plusieurs centres d'intérêt, comme la course à 
      pied, l'histoire, l'architecture, et l'urbanisme.
      <br />
      Je suis aussi un grand amoureux des animaux.
      </p>
    `
  }
];

export default collapseData;
